import ApiService from "@/common/api.service";
import { COMPANY_ID } from "@/common/config.js";

import { GET_RECENT_NEWS_LIST } from "./actions.type";
import { SET_RECENT_NEWS_LIST } from "./mutations.type";

const state = {
  errors: {},
  newsList: []
};

const getters = {
  newsList(state) {
    return state.newsList;
  }
};

const actions = {
  [GET_RECENT_NEWS_LIST](context) {
    return ApiService.get(
      `v1/newses?limit=10&offset=0&company_id=${COMPANY_ID}`
    )
      .then(({ data }) => {
        context.commit(SET_RECENT_NEWS_LIST, data);
      })
      .catch(() => {
        // #todo SET_ERROR cannot work in multiple states
        // context.commit(SET_ERROR, response.data.errors)
      });
  },
};

const mutations = {
  [SET_RECENT_NEWS_LIST](state, payload) {
    state.newsList = payload || [];
    state.errors = {};
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
